import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

import { BlockedDatePicker } from "../Utilities/DatePicker";

// Add Blocked Period Form
export default function AddBlockedForm(props: {
  show: boolean;
  onHide: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  startDate?: string | null;
  endDate?: string | null;
  name?: string;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={props.show} onClose={props.onHide}>
      <DialogTitle
        style={{
          color: "#525252",
          marginBottom: -25,
        }}
      >
        {t("Add blocked periods")}
      </DialogTitle>
      <hr />
      <form onSubmit={props.onSubmit} onReset={props.onHide}>
        <DialogContent style={{ padding: "12px 24px" }}>
          <BlockedDatePicker
            startDate={props.startDate}
            endDate={props.endDate}
            name={props.name}
          />
        </DialogContent>
        <DialogActions>
          <Button
            type="reset"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#333333",
              textTransform: "capitalize",
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "var(--text-primary)",
              color: "#ffffff",
              textTransform: "capitalize",
            }}
          >
            {t("Done")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
